/**
 *
 * @module drmClientConfiguration
 *
 */

import ServiceClientConfiguration from './../configuration/serviceClientConfiguration';

/**
 *
 * @class DrmClientConfiguration
 * @extends {ServiceClientConfiguration}
 * @desc Provides configuration information used by the DrmClient.
 *
 */
export default class DrmClientConfiguration extends ServiceClientConfiguration {}



// WEBPACK FOOTER //
// ./src/services/drm/drmClientConfiguration.js